export const PERMISSIONS = {
  MANAGE_GROUPS : "MANAGE_GROUPS",
  MANAGE_USERS : "MANAGE_USERS",
  CMP_ACCESS : "ROLE_BASIC",
  TENANT_CREATE : "TENANT_CREATE",
}

export const SERVICE_IDS = {
  ADMIN: "1",
  CMP : "2",
  SMARTLABEL: "3",
  MENU: "4"
}

export const STATUS = {
  NEVER: "Never Active",
  THIS_MONTH: "Active this month",
  THREE_MONTHS: "Active in past 3 months",
  INACTIVE: "Inactive",
  DELETED: "Deleted"
}